import React, { useContext, useEffect } from "react";
import { Communication } from "../../contexts/communicationContext";
import { LanguageContext } from "../../contexts/languageContext";
import { Auth } from "../../contexts/ridersUserContext";
import ErrorPage from "../../pages/errorPage";
import { ILayoutProps } from "../../types";
import { FileSystem, Screen } from "../vs-code";
import EditorLayout from "./EditorLayout";
import moment from "moment";
import FS from "@isomorphic-git/lightning-fs";

const Layout: React.FC<ILayoutProps> = ({ children }) => {
  const { user, loading, project, community, mode, verifyError } = useContext<any>(
    Auth.context
  );

  const { language } = useContext<any>(LanguageContext);

  const [lfs, setLfs] = React.useState<any>(null);
  const [uid, setUid] = React.useState<string>(moment().unix().toString());

  useEffect(() => {
    if (project === undefined) {
      document.getElementById("loading")?.remove();
    } else if (!loading) {
      document.getElementById("loading")?.remove();
    } else {
      if (user && project) {
        const fs_name = `${user.userFrom}_${user.id}_${project.session_id}_fs${mode === "preview" ? `_preview_${uid}` : `_editor_${uid}`
          }`;

        let LFS = new FS(
          project.storage !== "none"
            ? fs_name
            : `${user.username || user.id}/${project.project_id}`
        );

        setLfs(LFS);
        let fs = LFS.promises;
        window.pfs = fs;
      }
    }
  }, [project, loading, user]);

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-arduino-green-dark dark:bg-vs-dark-background text-vs-dark-panel dark:text-white">
      {!user ? (
        <ErrorPage community={community}>
          <div>
            {verifyError ? (
              <div>
                {language?.toLowerCase() === "en"
                  ? "Active session not found. Please reload your project."
                  : "Aktif oturum bulunamadı. Lütfen projeyi tekrar yükleyin."
                }
              </div>
            ) : (
              <div>
                403 Forbidden | <span> </span>
                <a
                  href={
                    community === "edusim"
                      ? "https://simulearn.eba.gov.tr"
                      : "https://riders.ai"
                  }
                  className="bg-vs-dark-toolbar rounded-md px-2 py-1"
                >
                  Click Here To Authorize
                </a>
              </div>

            )}
          </div>
        </ErrorPage>
      ) : !project ? (
        <ErrorPage community={community}>
          <div>
            {community === "edusim" ? "Edusim" : "Riders"} Can't Find Project |{" "}
            <a
              href={
                community === "edusim"
                  ? "https://simulearn.eba.gov.tr"
                  : "https://riders.ai"
              }
              className="bg-arduino-green-dark dark:bg-vs-dark-toolbar rounded-md px-2 py-1"
            >
              Click Here To Explore
            </a>
          </div>
        </ErrorPage>
      ) : (
        <FileSystem LFS={lfs} base_path="/base" uid={uid}>
          {!loading && (
            <Screen project={project} env={community}>
              <Communication>
                <EditorLayout />
              </Communication>
            </Screen>
          )}
        </FileSystem>
      )}
    </div>
  );
};
export default Layout;
